import * as i18n from 'i18next';
const XHR = require('i18next-xhr-backend');
import { cacheBust } from './cacheBust';

// HACK: InjectedTranslateProps (from react-i18next) has "t?" which gives errors
//       that 't may be undefined'. But the "?" part is a hack because the TypeScript
//       type system doesn't support type subtraction yet.
//       So we create our own copy with a mandatory t member.
export type TranslateProps = {
    t: i18n.TranslationFunction;
};

let instance: i18n.i18n;

const langQueryParamRegex = /(?:\?|&)lang=(\w{2}(?:-\w{2,3})?)(?:&|$)/i;

function getLanguageFromQueryString() {
    const match = window && langQueryParamRegex.exec(window.location.search);
    return match && match[1];
}

function makeInstance(initCallback: (errors: string[] | null) => void) {
    const browserLanguageCode = navigator && navigator.language;
    const savedLanguageCode = window && window.localStorage && window.localStorage.getItem('lang');
    const overrideLanguageCode = getLanguageFromQueryString();

    if (browserLanguageCode) {
        console.log(`Browser configured for "${browserLanguageCode}"`);
    }
    if (savedLanguageCode) {
        console.log(`Application configured for "${savedLanguageCode}"`);
    }
    if (overrideLanguageCode) {
        console.log(`Override specified as "${overrideLanguageCode}"`);
    }

    const _i18n = i18n
        .use(XHR)
        .init({
            debug: process.env.NODE_ENV === 'development',

            // Set Default language to English
            fallbackLng: 'en',

            // Don't attempt to load 'en-US' when 'en' is active
            load: 'currentOnly',

            // Start off with the value from the query string, then look to localStorage,
            // then default to the browser language.
            lng: overrideLanguageCode || savedLanguageCode || browserLanguageCode,

            // Set so variables in translations are encased by {}
            interpolation: {
                prefix: '{',
                suffix: '}',
            },

            // Change path to where resource files will be found
            backend: {
                loadPath: `/Client/{lng}/{ns}.json?v=${cacheBust}`,
            },

            // Not actually using this feature, but the default '.' is part of the source keys.
            // So pick some character that isn't used in our keys.
            keySeparator: '~',

            // we only have one namespace, so the separator should be something that will not come up in common strings
            nsSeparator: ':::',

            initImmediate: true, // Note: the i18n logic is backwards. initImmediate:true actually does the async load
        },
        (errors: string[] | null, t: {}) => {
            initCallback(errors);
        });
    
    return _i18n;
}

export function createInstance(initCallback: (errors: string[] | null) => void) {
    if (!instance) {
        instance = makeInstance(initCallback);
    }
    return instance;
}

export function getInstance() {
    if (!instance) {
        throw new Error("i18n instance hasn't been initialized yet");
    }
    return instance;
}



// WEBPACK FOOTER //
// ./src/util/i18n.ts